import { useEffect, type RefObject } from "react";
import gsap from "gsap";
import { SplitText } from "gsap/SplitText";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(SplitText, ScrollTrigger);

// Splits a headline into words and reveals them one by one as it scrolls
// into view — fires on initial load (the hero heading already satisfies the
// trigger position) and replays if the user scrolls away and back.
export function useSplitHeadlineReveal(ref: RefObject<HTMLElement>) {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const split = new SplitText(el, { type: "words" });
    gsap.set(split.words, { opacity: 0, y: "1em" });

    const tween = gsap.to(split.words, {
      opacity: 1,
      y: "0em",
      duration: 1,
      delay: 0.35,
      ease: "power3.out",
      stagger: 0.11,
      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        toggleActions: "restart none none reverse",
      },
    });

    return () => {
      tween.scrollTrigger?.kill();
      tween.kill();
      split.revert();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
